module.exports = __webpack_public_path__ + "static/playtimegif-7df5efbf93228d6aea0d0d6fca7e75e3.gif";